import { myFetch, HttpMethod } from './baseService';

export interface Apartamento {
  apt_codigo: string;
  apt_nombre: string;
}

export interface ApartamentoConPropietario {
  apt_unidad_residencial?: string;
  apt_unidad_residencial_nombre?: string;
  apt_torre?: string;
  apt_torre_nombre?: string;
  apt_codigo: string;
  apt_nombre: string;
  apt_piso?: number;
  apt_cero?: number;
  apt_usuario_propietario?: string;
  apt_estatus?: string;
  apt_bloqueado_para_votar?: number;
  apt_bloqueado_para_votar_texto?: string;
  apt_bloqueado_para_votar_razon?: string;
  [key: string]: any;
}

export interface ObtenerApartamentosRequest {
  "unidad residencial codigo": string;
  "torre codigo": string;
}

export interface ObtenerApartamentosConPropietariosRequest {
  "unidad residencial codigo": string;
  "torre codigo": string;
  "apartamento codigo": string;
}

export interface GeneracionLlaveSecretaRequest {
  apartamento_codigo: string;
  correo_electronico: string;
}

export interface BloquearParaVotarRequest {
  apartamento_codigo: string;
  bloqueado_para_votar: number;
  razon_del_bloqueo: string;
}

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export const obtenerApartamentos = async (payload: ObtenerApartamentosRequest) => {
  const envelope = await myFetch<ApiEnvelope<Apartamento[]>>(
    'apartamento/ObtenerTodos',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

export const obtenerApartamentosConPropietarios = async (payload: ObtenerApartamentosConPropietariosRequest) => {
  const envelope = await myFetch<ApiEnvelope<ApartamentoConPropietario[]>>(
    'apartamento/ObtenerTodosConPropietarios',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

export const generacionLlaveSecretaParaRegistro = async (payload: GeneracionLlaveSecretaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'apartamento/GeneracionLlaveSecretaParaRegistro',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

export const bloquearParaVotar = async (payload: BloquearParaVotarRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'apartamento/BloquearParaVotar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};
